import styled from 'styled-components';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { IconButton } from '@material-ui/core';

import theme from '../../../styles/defaultTheme';

export const StyledDatepicker = styled(KeyboardDatePicker)`
    height: 44px;
    min-width: 100px;
    width: 100%;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.lightGreyLink40} !important;
    outline: none;
    padding: 0 16px;
    font-size: ${theme.font.size16};
    transition: all 0.3s;
    flex: 1;
    text-transform: uppercase;
    box-shadow: none;
    
    .MuiInputBase-root {
        align-items: center;
        border: none;
        border-radius: inherit;
        box-sizing: border-box;
        color: ${(props) => props.theme.black} !important;
        cursor: inherit;
        display: inline-flex;
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        height: inherit;
        letter-spacing: inherit;
        line-height: inherit;
        outline: none;
        overflow: hidden;
        position: relative;
        
        fieldset {
            border: none;   
        }
    }
    
    input {
        color: ${(props) => props.theme.black} !important;

        &::placeholder {
            color: ${(props) => props.theme.blackLink} !important;
            font-size: ${theme.font.size16};
            opacity: initial;

        }

        &:-webkit-autofill {
            box-shadow: 0 0 0 30px white inset !important;
        }

        &:autofill {
            box-shadow: 0 0 0 30px white inset !important;
        }
    }

    &.error {
        border: 1px solid ${(props) => props.theme.redLink} !important;

        input {
            color: ${(props) => props.theme.red} !important;

            &::placeholder {
                color: ${(props) => props.theme.redLink} !important;   
            }
        }
    }

    &:not(.error):not(.disabled):hover,
    &:not(.error):not(.disabled):focus-within {
        border: 1px solid ${(props) => props.theme.orangeLink} !important;
    }

    &.disabled {
        background-color: ${(props) => props.theme.disabledGrey10};

        input {
            color: ${(props) => props.theme.greyLink} !important;

            &::placeholder {
                color: ${(props) => props.theme.greyLink} !important;
            }
        }

        button span.material-icons-outlined {
            color: ${(props) => props.theme.grey} !important;
        }
    }
`;

export const StyleIconButton = styled(IconButton)`
    &:hover {
        border: 1px solid ${(props) => props.theme.orange} !important;
        background: transparent !important;
        color: ${(props) => props.theme.black} !important;
    }
`;

export const SpanError = styled.span`
    color: ${(props) => props.theme.red};
    font-size: ${theme.font.size12};
    margin-top: 4px;
    padding-left: 2px;
`;

export const ContainerInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    & :first-child{
        background-color: ${(props) => props.theme.white};
        border-color: #FFF333;
    }

    & + div {
        position: absolute;
        right: 20px;
        width: 10px;
        
        
        &.icon-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: auto;
        }
    }

    & .MuiIconButton-root {
        padding: 0;
    }

    & .MuiOutlinedInput-adornedEnd {
        padding-right: 16px;
    }
`;
